import styled from 'styled-components';

const MessageContainer = styled('div')<{ show: boolean | undefined | null }>`
  position: relative;
  display: block;
  transition: height ${(props) => props.theme.transitions.normal};
  min-height: ${(props) => (props.show ? '28px' : '0px')};
`;

export default MessageContainer;
